module.exports = __webpack_public_path__ + "static/media/balearic-islands.c701796b.svg";